import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { ElMessage, ElSwitch, ElTree } from "element-plus";
import { computed, onMounted, reactive, ref, toRefs, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { USERINFO } from "@/store/mutation-types";
import apis from "@/api";
import dayjs from "dayjs";
import AddAside from "../components/AddAside";
import common from "../composables/common";
import { DArrowRight, Delete } from '@element-plus/icons-vue';
export default {
  name: "Add",
  components: {
    AddAside,
    ElTree,
    ElSwitch,
    Delete,
    DArrowRight
  },
  setup(props, ctx) {
    const {
      commonData,
      srcProcs,
      disabledDate
    } = common();
    const router = useRouter();
    const route = useRoute();
    const treeLeft = ref(null);
    const formRef = ref(null);
    const data = reactive({
      filterText: '',
      saveLoading: false,
      auditLoading: false,
      posTree: [],
      defaultPosChecked: [],
      positionsTemp: [],
      positions: [],
      demand: {
        belongDepart: '0000'
      },
      demandId: route.query.demandId,
      defaultProps: {
        children: "children",
        label: "label",
        disabled: function (data, node) {
          if (node.childNodes && node.childNodes.length > 0) {
            return true;
          }
        }
      },
      rules: {
        name: [{
          required: true,
          message: "请输入需求名称",
          trigger: "blur"
        }],
        planFinishDate: [{
          required: true,
          message: "请选择素材计划完成日期",
          trigger: "blur"
        }],
        validDate: [{
          required: true,
          message: "请选择素材有效期",
          trigger: "blur"
        }],
        remark: [{
          required: true,
          message: "请输入需求内容",
          trigger: "blur"
        }],
        position: [{
          validator: validatePosition,
          trigger: "blur"
        }]
      }
    });
    function validatePosition(rule, value, callback) {
      if (data.positions.length <= 0) {
        callback(new Error("请选择运营位"));
      } else {
        callback();
      }
    }
    watch(() => data.filterText, value => {
      treeLeft.value.filter(value);
    });
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    const handleCheck = async () => {
      let newPositions = [];
      let keys = treeLeft.value.getCheckedKeys(true);
      if (keys.length > 20) {
        // 选中超20个运营位
        ElMessage.warning('运营位选择超上限，请重新选择或联系管理员');
        newPositions = data.positionsTemp;
      } else {
        for (let i = 0; i < keys.length; i++) {
          let isHas = false;
          for (let j = 0; j < data.positionsTemp.length; j++) {
            if (keys[i] == data.positionsTemp[j].id) {
              newPositions.push(data.positionsTemp[j]);
              isHas = true;
              break;
            }
          }
          if (!isHas) {
            await apis.queryPositionById(keys[i]).then(res => {
              if (res.success) {
                newPositions.push({
                  positionId: keys[i],
                  label: res.data.nodeAllName,
                  positionAllname: res.data.nodeAllName,
                  isUploadSrc: 1
                });
              } else {
                ElMessage.error(res.msg);
              }
            });
          }
        }
      }
      data.positionsTemp = newPositions;
    };
    const initPositions = () => {
      apis.queryPositionTree('offline').then(res => {
        if (res.success) {
          res.data.forEach(p => {
            data.posTree = p.children;
          });
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const handleSubmit = state => {
      formRef.value.validate(valid => {
        if (valid) {
          if (state == 0) {
            data.saveLoading = true;
          } else {
            data.auditLoading = true;
          }
          data.demand.type = 2;
          data.demand.state = state;
          data.demand.planFinishDate = dayjs(data.demand.planFinishDate).format("YYYY-MM-DD 23:59:59");
          data.demand.validDateBgn = dayjs(data.demand.validDate[0]).format("YYYY-MM-DD HH:mm:ss");
          data.demand.validDateEnd = dayjs(data.demand.validDate[1]).format("YYYY-MM-DD HH:mm:ss");
          data.demand.positions = data.positions;
          console.log(data.demand);
          if (data.demandId) {
            apis.editDemand(data.demand).then(res => {
              if (res.success) {
                router.push("/my-needs/list");
              } else {
                ElMessage.error(res.msg);
              }
            }).finally(() => {
              data.saveLoading = false;
              data.auditLoading = false;
            });
          } else {
            apis.addDemand(data.demand).then(res => {
              if (res.success) {
                router.push("/my-needs/list");
              } else {
                ElMessage.error(res.msg);
              }
            }).finally(() => {
              data.saveLoading = false;
              data.auditLoading = false;
            });
          }
        }
      });
    };
    const left2right = () => {
      data.positions = data.positionsTemp;
      if (data.positionsTemp && data.positionsTemp.length > 0) {
        data.demand.positionFlag = data.positionsTemp[0].id;
      } else {
        data.demand.positionFlag = '';
      }
    };
    const loadDemand = () => {
      apis.getDemandById({
        id: data.demandId
      }).then(res => {
        if (res.success) {
          data.demand = res.data;
          const validDate = [res.data.validDateBgn, res.data.validDateEnd];
          data.demand.validDate = validDate;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const loadPosConfOfDemand = () => {
      apis.getPosConfByDid({
        demandId: data.demandId
      }).then(res => {
        if (res.success && res.data) {
          const checked = [];
          res.data.forEach(p => {
            checked.push(p.positionId);
            data.positions.push({
              positionId: p.positionId,
              label: p.positionAllname,
              positionAllname: p.positionAllname,
              isUploadSrc: p.isUploadSrc
            });
          });
          data.defaultPosChecked = checked;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const userInfo = computed(() => {
      // return store.state.userInfo
      const userInfo = window.localStorage.getItem(USERINFO);
      return JSON.parse(userInfo);
    });
    const belongDepartChange = val => {
      data.demand.belongDepart = val;
    };
    const removePosition = (index, postionId) => {
      data.positions.splice(index, 1);
      treeLeft.value.setChecked(postionId, false, false);
    };
    const clearPosSelected = () => {
      data.positions = [];
      treeLeft.value.setCheckedKeys([]);
    };
    const setPosNeedSrc = val => {
      console.log('val: ', val);
      for (let i = 0; data.positions.length > i; i++) {
        data.positions[i].isUploadSrc = val;
      }
    };
    onMounted(() => {
      initPositions();
      if (data.demandId) {
        loadDemand();
        loadPosConfOfDemand();
      } else {
        const validDate = [dayjs().set('hour', 0).set('minute', 0).set('second', 0), dayjs().add(1, 'year').set('hour', 23).set('minute', 59).set('second', 59)];
        data.demand.validDate = validDate;
      }
    });
    return {
      ...toRefs(data),
      ...toRefs(commonData),
      treeLeft,
      formRef,
      userInfo,
      srcProcs,
      handleCheck,
      handleSubmit,
      left2right,
      removePosition,
      filterNode,
      clearPosSelected,
      setPosNeedSrc,
      disabledDate,
      belongDepartChange
    };
  }
};